export const removeTrailingSlash = (str: string): string => {
  if (str && str.length > 0 && str.endsWith('/')) {
    str = str.substring(0, str.length - 1)
  }

  return str
}

export const addTrailingSlash = (str: string): string => {
  if (str && str.length > 0 && !str.endsWith('/')) {
    str += '/'
  }

  return str
}

export const removeLeadingSlash = (str: string): string => {
  if (str.startsWith('/')) {
    str = str.substring(1)
  }

  return str
}

export const addLeadingSlash = (str: string): string => {
  if (str && !str.startsWith('/')) {
    str = `/${str}`
  }

  return str
}

export const validateUrl = (url: string): string | boolean => {
  const regex =
    /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,}\b(?:[-a-zA-Z0-9@:%_+.~#?&/=]*)/u

  const matches = regex.exec(url)

  if (matches) {
    return matches.length > 0
  }
  return false
}
